import { render, staticRenderFns } from "./index-tabs.vue?vue&type=template&id=0c8c076b&scoped=true&"
import script from "./index-tabs.vue?vue&type=script&lang=js&"
export * from "./index-tabs.vue?vue&type=script&lang=js&"
import style0 from "./index-tabs.vue?vue&type=style&index=0&id=0c8c076b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8c076b",
  null
  
)

export default component.exports